import { render, staticRenderFns } from "./DashboardOrders.vue?vue&type=template&id=4f2f7844"
import script from "./DashboardOrders.vue?vue&type=script&lang=js"
export * from "./DashboardOrders.vue?vue&type=script&lang=js"
import style0 from "./DashboardOrders.vue?vue&type=style&index=0&id=4f2f7844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports